import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/dashboard_elements/certificate_progress');
  return response.data;
}

export default {
  index,
};
